// Pure month-grid generation for the calendar. Extracted from
// calendar_component.jsx so it can be unit-tested (node --test) on its own.

function getFirstDayOfWeek(date) {
  const firstDay = new Date(date);
  const dayOfWeek = firstDay.getDay(); // 0 (Sunday) to 6 (Saturday)
  const diff = firstDay.getDate() - dayOfWeek;
  firstDay.setDate(diff);
  return firstDay;
}

// month is 0-indexed (0 = January). Returns an array of weeks, each an array of
// 7 Date objects. Keeps the historical 5-week minimum but adds a 6th week when
// the month's final day would otherwise fall off the grid (e.g. a 31-day month
// starting late in the week) so the last day and its highlight always render.
function createWeeksToRender(month, year) {
  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const dayToStartOn = getFirstDayOfWeek(firstDayOfMonth);
  const weeks = [];
  let weekToGenerate = 0;
  let lastRenderedDay = dayToStartOn;
  while (weekToGenerate < 5 || lastRenderedDay < lastDayOfMonth) {
    const daysInWeek = [];
    const dayToStartForThisWeek = new Date(dayToStartOn);
    dayToStartForThisWeek.setDate(dayToStartOn.getDate() + weekToGenerate * 7);
    for (let dayOfWeekGenerate = 0; dayOfWeekGenerate < 7; dayOfWeekGenerate++) {
      const dayToGenerate = new Date(dayToStartForThisWeek);
      dayToGenerate.setDate(dayToStartForThisWeek.getDate() + dayOfWeekGenerate);
      daysInWeek.push(dayToGenerate);
      lastRenderedDay = dayToGenerate;
    }
    weeks.push(daysInWeek);
    weekToGenerate += 1;
    if (weekToGenerate >= 6) break; // a month never spans more than 6 weeks
  }
  return weeks;
}

module.exports = { getFirstDayOfWeek, createWeeksToRender };
